import { Center } from "@chakra-ui/react";
import { Navigate, useLocation, useParams } from "react-router";

import InvalidRoute from "@/app/pages/InvalidRoute";
import { DelayedSpinner } from "@/common/components/DelayedSpinner";
import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { useFeatureNamesData } from "@/feature/data/useFeatureNamesData";
import { FeatureUrl } from "@reflag/shared/urls";

export default function GoToFlagKey() {
  const { data: features, isLoading } = useFeatureNamesData();
  const { flagKey, "*": wildcardPath } = useParams();
  const { search, hash } = useLocation();
  const { env } = useEnvironment();

  if (isLoading) {
    return (
      <Center flexGrow={1}>
        <DelayedSpinner />
      </Center>
    );
  }

  const foundFeature = features?.find((f) => f.key === flagKey);
  if (!foundFeature) {
    return <InvalidRoute />;
  }

  const url = FeatureUrl(env, foundFeature);
  const urlWithPath = wildcardPath ? url + "/" + wildcardPath : url;

  return <Navigate to={`${urlWithPath}${search}${hash}`} replace />;
}
